import { render } from "./Pension.vue?vue&type=template&id=68136962"
import script from "./Pension.vue?vue&type=script&lang=js"
export * from "./Pension.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__